import {
  ArchiveBoxIcon,
  BanknotesIcon,
  BuildingOffice2Icon,
  ChartBarSquareIcon,
  CircleStackIcon,
  ClipboardDocumentCheckIcon,
  ClipboardDocumentIcon,
  Cog6ToothIcon,
  DocumentDuplicateIcon,
  GiftIcon,
  IdentificationIcon,
  LockClosedIcon,
  MegaphoneIcon,
  NewspaperIcon,
  RectangleStackIcon,
  TrophyIcon,
  UserGroupIcon,
  UsersIcon,
} from "@heroicons/react/24/outline";
import {
  AutoFacAconfigationsPage,
  AutoFacAconfigationsParticipantsPage,
  BankingTrayOffersPage,
  BankingTrayPage,
  BatchReportingPage,
  BrokerPage,
  BrokersPage,
  CancelledOffersPage,
  ClaimSharePaymentsPage,
  ClaimsKEKPage,
  ClaimsPage,
  ClaimsSharesPaymentKEKPage,
  ClassOFBusinessKEKPage,
  ClassOfBusinessPage,
  CreateClosingKekPage,
  CreateClosingPage,
  CreateSlipKEKPage,
  CreateSlipPage,
  CreditNotesKEKPage,
  CreditNotesPage,
  DashboardKEKPage,
  DashboardPage,
  EmployeesKEKPage,
  EmployeesPage,
  EndorsementPage,
  EndorsementsPage,
  EndorsementsPageKEK,
  FinanceReportsPage,
  InsurerKEKPage,
  InsurerPage,
  InsurerPaymentsKEKPage,
  InsurerPaymentsPage,
  InsurersKEKPage,
  InsurersPage,
  ManageTreatyPage,
  NotificationsPage,
  OfferPage,
  PlaceItOffersPage,
  PlaceItPromotionsPage,
  PlaceItRewardsPage,
  ProfilePage,
  ReInsurerKEKPage,
  ReInsurerPage,
  ReInsurerPaymentsPage,
  ReInsurersKEKPage,
  ReInsurersPage,
  ReinstatementOffersPage,
  ReportsKEKPage,
  ReportsPage,
  ResetPasswordPage,
  SettingsPage,
  SignInPage,
  TreatiesPage,
  TreatyClaimsPage,
  TreatyProgramDeductionsPage,
  TreatyProgramsPage,
  TreatyReportsPage,
  TreatySchedulePage,
  UnapprovedClosingsPage,
  UnderwritersPage,
  ViewClaimSharesPage,
  ViewClaimsKEKPage,
  ViewClaimsPage,
  ViewClaimsSharesKEKPage,
  ViewOfferKekPage,
  ViewTreatyPage,
} from "pages";
import { Domain, UserPermission } from "_graphql/cache/auth";
import { Outlet, Route } from "react-location";

import { DocumentPlusIcon } from "@heroicons/react/24/solid";
import LeaderboardPage from "pages/leaderboard";
import PointRedemptionsPage from "pages/points-redemptions";
import ProductionReportsPage from "pages/production-reports";
import TargetBadgesPage from "pages/place-it-rewards-targets";
import TargetRatesPage from "pages/place-it-rewards-target-rates";
import TreatyClaimParticipantsPage from "pages/treaty-claim-participants";
import TreatyClaimPaymentsPage from "pages/treaty-claim-payments";
import { DocumentMinusIcon } from "@heroicons/react/20/solid";

export type RouteProps = Omit<Route, "children"> & {
  withPermissions?: UserPermission[];
  navigation?: boolean;
  sidebar?: { label: string; icon: any };
  children?: RouteProps[];
  withDomains?: Domain[];
};

const routes: RouteProps[] = [
  {
    path: "/",
    element: <Outlet />,
    sidebar: {
      label: "Dashboard",
      icon: ChartBarSquareIcon,
    },
    withDomains: ["Visal", "Comfy"],
    meta: {
      layout: "App",
      breadcrumb: () => "Dashboard",
      section: "General",
    },
    children: [
      {
        id: "all",
        path: "/",
        element: <DashboardPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
  },
  {
    path: "/",
    element: <Outlet />,
    sidebar: {
      label: "Dashboard",
      icon: ChartBarSquareIcon,
    },
    withDomains: ["KEK"],
    meta: {
      layout: "App",
      breadcrumb: () => "Dashboard",
      section: "General",
    },
    children: [
      {
        id: "all",
        path: "/",
        element: <DashboardKEKPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
  },
  {
    path: "/leaderboard",
    element: <Outlet />,
    sidebar: {
      label: "Target Monitor",
      icon: TrophyIcon,
    },
    meta: {
      layout: "App",
      breadcrumb: () => "Target Monitor",
      section: "General",
    },
    withPermissions: ["analytics:*"],
    withDomains: ["Visal", "Comfy"],
    children: [
      {
        id: "all",
        path: "/",
        element: <LeaderboardPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
  },
  {
    path: "create-slip",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Create Slip",
      section: "Facultative Businesses",
    },
    sidebar: {
      label: "Create Slip",
      icon: DocumentPlusIcon,
    },
    withPermissions: [
      "*:*",
      "offers:*",
      "offers:view",
      "offers:manage",
      "offers:create",
      "offers:update",
    ],
    withDomains: ["Visal", "Comfy"],
    children: [
      {
        id: "all",
        path: "/",
        element: <CreateSlipPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
      {
        path: ":offer/view",
        element: <OfferPage />,
        meta: {
          layout: "App",
          section: "General",
          breadcrumb: () => `View Slip`,
        },
      },
    ],
  },
  {
    path: "create-slip",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Create Slip",
      section: "Facultative Businesses",
    },
    sidebar: {
      label: "Create Slip",
      icon: DocumentPlusIcon,
    },
    withPermissions: [
      "*:*",
      "offers:*",
      "offers:view",
      "offers:manage",
      "offers:create",
      "offers:update",
    ],
    withDomains: ["KEK"],
    children: [
      {
        id: "all",
        path: "/",
        element: <CreateSlipKEKPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
      {
        path: ":offer/view",
        element: <ViewOfferKekPage />,
        meta: {
          layout: "App",
          section: "General",
          breadcrumb: () => `View Slip`,
        },
      },
    ],
  },
  {
    path: "unapproved-closings",
    element: <Outlet />,
    withPermissions: ["*:*", "offers:*", "offers:approve"],
    withDomains: ["KEK"],
    meta: {
      layout: "App",
      breadcrumb: () => "Unapproved Closings",
      section: "Facultative Businesses",
    },
    sidebar: {
      label: "Unapproved Closings",
      icon: DocumentPlusIcon,
    },
    children: [
      {
        id: "all",
        path: "/",
        element: <UnapprovedClosingsPage />,
        meta: {
          layout: "App",
          section: "General",
        },
        children: [],
      },
      {
        path: ":offer/credit-notes",
        element: <CreditNotesPage />,
        meta: {
          layout: "App",
          section: "General",
          breadcrumb: () => "View Credit Notes",
        },
      },
      {
        path: ":treaty/view",
        element: <Outlet />,
        meta: {
          layout: "App",
          section: "General",
          breadcrumb: () => "View Treaty",
        },
        children: [
          {
            path: "/",
            element: <ViewTreatyPage />,
            meta: {
              layout: "App",
              section: "General",
              // breadcrumb: () => "View Treaty",
            },
          },
          {
            path: ":ref/manage-treaty",
            element: <ManageTreatyPage />,
            meta: {
              layout: "App",
              section: "General",
              breadcrumb: ({ ref }: any) =>
                `Manage Treaty - ${ref?.replaceAll("__", "/")}`,
            },
          },
        ],
      },
    ],
  },
  {
    path: "create-closing",
    element: <Outlet />,
    withPermissions: [
      "*:*",
      "offers:*",
      "offers:view",
      "offers:manage",
      "offers:create",
      "offers:update",
      "offers:reinstate",
      "offers:approve",
      "offers:payment",
    ],
    withDomains: ["KEK"],
    meta: {
      layout: "App",
      breadcrumb: () => "Create Closing",
      section: "Facultative Businesses",
    },
    sidebar: {
      label: "Create Closing",
      icon: LockClosedIcon,
    },
    children: [
      {
        id: "all",
        path: "/",
        element: <CreateClosingKekPage />,
        meta: {
          layout: "App",
          section: "General",
        },
        children: [],
      },
      {
        path: ":offer/credit-notes",
        element: <CreditNotesKEKPage />,
        meta: {
          layout: "App",
          section: "General",
          breadcrumb: () => "View Credit Notes",
        },
      },
    ],
  },
  {
    path: "create-closing",
    element: <Outlet />,
    withPermissions: [
      "*:*",
      "offers:*",
      "offers:view",
      "offers:manage",
      "offers:create",
      "offers:update",
      "offers:reinstate",
      "offers:approve",
      "offers:payment",
    ],
    withDomains: ["Visal", "Comfy"],
    meta: {
      layout: "App",
      breadcrumb: () => "Create Closing",
      section: "Facultative Businesses",
    },
    sidebar: {
      label: "Create Closing",
      icon: LockClosedIcon,
    },
    children: [
      {
        id: "all",
        path: "/",
        element: <CreateClosingPage />,
        meta: {
          layout: "App",
          section: "General",
        },
        children: [],
      },
      {
        path: ":offer/credit-notes",
        element: <CreditNotesPage />,
        meta: {
          layout: "App",
          section: "General",
          breadcrumb: () => "View Credit Notes",
        },
      },
    ],
  },
  {
    path: "reinstatement-offers",
    element: <Outlet />,
    withPermissions: [
      "*:*",
      "offers:*",
      "offers:view",
      "offers:manage",
      "offers:reinstate",
    ],
    withDomains: ["KEK"],
    meta: {
      layout: "App",
      breadcrumb: () => "Reinstatement Offers",
      section: "Facultative Businesses",
    },
    sidebar: {
      label: "Reinstatement Offers",
      icon: CircleStackIcon,
    },
    children: [
      {
        id: "all",
        path: "/",
        element: <ReinstatementOffersPage />,
        meta: {
          layout: "App",
          section: "General",
        },
        children: [],
      },
    ],
  },
  {
    path: "banking-tray",
    element: <Outlet />,
    withPermissions: ["*:*", "offers:*", "offers:payment"],
    withDomains: ["KEK"],
    meta: {
      layout: "App",
      breadcrumb: () => "Banking Tray",
      section: "Finance",
    },
    sidebar: {
      label: "Banking Tray",
      icon: BanknotesIcon,
    },
    children: [
      {
        id: "all",
        path: "/",
        element: <BankingTrayPage />,
        meta: {
          layout: "App",
          section: "General",
        },
        children: [],
      },
      {
        id: "view",
        path: ":id/view",
        element: <BankingTrayOffersPage />,
        meta: {
          layout: "App",
          section: "General",
          breadcrumb: ({ cheque_number }: any) => `Offers Related`,
        },
        children: [],
      },
    ],
  },
  {
    path: "endorsements",
    element: <Outlet />,
    withPermissions: [
      "*:*",
      "endorsements:*",
      "endorsements:view",
      "endorsements:manage",
      "endorsements:create",
      "endorsements:update",
    ],
    withDomains: ["Visal", "Comfy"],
    meta: {
      layout: "App",
      breadcrumb: () => "Endorsements",
      section: "Facultative Businesses",
    },
    sidebar: {
      label: "Endorsements",
      icon: ClipboardDocumentCheckIcon,
    },
    children: [
      {
        path: "/",
        element: <EndorsementsPage />,
        meta: {
          layout: "App",
          section: "Facultative Businesses",
        },
        children: [],
      },
      {
        path: ":endorsement/endorsement/:endorsement_policy_number",
        element: <EndorsementPage />,
        meta: {
          layout: "App",
          section: "Facultative Businesses",
          breadcrumb: ({
            endorsement_policy_number,
          }: {
            endorsement_policy_number: string;
          }) => endorsement_policy_number,
        },
        children: [],
      },
    ],
  },
  {
    path: "endorsements",
    element: <Outlet />,
    withPermissions: [
      "*:*",
      "endorsements:*",
      "endorsements:view",
      "endorsements:manage",
      "endorsements:create",
      "endorsements:update",
    ],
    withDomains: ["KEK"],
    meta: {
      layout: "App",
      breadcrumb: () => "Endorsements",
      section: "Facultative Businesses",
    },
    sidebar: {
      label: "Endorsements",
      icon: ClipboardDocumentCheckIcon,
    },
    children: [
      {
        path: "/",
        element: <EndorsementsPageKEK />,
        meta: {
          layout: "App",
          section: "Facultative Businesses",
        },
        children: [],
      },
      {
        path: ":endorsement/endorsement/:endorsement_policy_number",
        element: <EndorsementPage />,
        meta: {
          layout: "App",
          section: "Facultative Businesses",
          breadcrumb: ({
            endorsement_policy_number,
          }: {
            endorsement_policy_number: string;
          }) => endorsement_policy_number,
        },
        children: [],
      },
    ],
  },
  {
    path: "insurers",
    withPermissions: [
      "*:*",
      "insurers:*",
      "insurers:manage",
      "insurers:create",
      "insurers:update",
    ],
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Insurers",
      section: "Clients",
    },
    sidebar: {
      label: "Insurers",
      icon: UsersIcon,
    },
    withDomains: ["Visal", "Comfy"],
    children: [
      {
        path: "/",
        element: <InsurersPage />,
        meta: {
          layout: "App",
          section: "Clients",
        },
        children: [],
      },
      {
        path: ":insurer/view",
        element: <Outlet />,
        meta: {
          layout: "App",
          section: "Clients",
          breadcrumb: () => "View Insurer",
        },
        children: [
          {
            path: "/",
            element: <InsurerPage />,
            meta: {
              layout: "App",
              section: "Clients",
            },
          },
          {
            path: ":offer/payments",
            element: <Outlet />,
            meta: {
              layout: "App",
              section: "Clients",
              breadcrumb: () => "View Payments",
            },
            children: [
              {
                path: "/",
                element: <InsurerPaymentsPage />,
                meta: {
                  layout: "App",
                  section: "Clients",
                },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "insurers",
    withPermissions: [
      "*:*",
      "insurers:*",
      "insurers:manage",
      "insurers:create",
      "insurers:update",
    ],
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Insurers",
      section: "Clients",
    },
    sidebar: {
      label: "Insurers",
      icon: UsersIcon,
    },
    withDomains: ["KEK"],
    children: [
      {
        path: "/",
        element: <InsurersKEKPage />,
        meta: {
          layout: "App",
          section: "Clients",
        },
        children: [],
      },
      {
        path: ":insurer/view",
        element: <Outlet />,
        meta: {
          layout: "App",
          section: "Clients",
          breadcrumb: () => "View Insurer",
        },
        children: [
          {
            path: "/",
            element: <InsurerKEKPage />,
            meta: {
              layout: "App",
              section: "Clients",
            },
          },
          {
            path: ":offer/payments",
            element: <Outlet />,
            meta: {
              layout: "App",
              section: "Clients",
              breadcrumb: () => "View Payments",
            },
            children: [
              {
                path: "/",
                element: <InsurerPaymentsKEKPage />,
                meta: {
                  layout: "App",
                  section: "Clients",
                },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "re-insurers",
    element: <Outlet />,
    withPermissions: [
      "*:*",
      "reinsurers:*",
      "reinsurers:manage",
      "reinsurers:create",
      "reinsurers:update",
    ],
    withDomains: ["KEK"],
    meta: {
      layout: "App",
      breadcrumb: () => "Re-Insurers",
      section: "Clients",
    },
    sidebar: {
      label: "Re-Insurers",
      icon: UserGroupIcon,
    },
    children: [
      {
        path: "/",
        element: <ReInsurersKEKPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
      {
        path: ":reInsurer",
        element: <Outlet />,
        meta: {
          layout: "App",
          section: "General",
          breadcrumb: () => "View Re-Insurer",
        },
        children: [
          {
            path: "/",
            element: <ReInsurerKEKPage />,
            meta: {
              layout: "App",
              section: "Clients",
            },
          },
          {
            path: ":offer_participant/payments/:offer",
            element: <ReInsurerPaymentsPage />,
            meta: {
              layout: "App",
              section: "Clients",
              breadcrumb: () => "View Re-Insurer Payments",
            },
          },
        ],
      },
    ],
  },
  {
    path: "re-insurers",
    element: <Outlet />,
    withPermissions: [
      "*:*",
      "reinsurers:*",
      "reinsurers:manage",
      "reinsurers:create",
      "reinsurers:update",
    ],
    withDomains: ["Visal", "Comfy"],
    meta: {
      layout: "App",
      breadcrumb: () => "Re-Insurers",
      section: "Clients",
    },
    sidebar: {
      label: "Re-Insurers",
      icon: UserGroupIcon,
    },
    children: [
      {
        path: "/",
        element: <ReInsurersPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
      {
        path: ":reInsurer",
        element: <Outlet />,
        meta: {
          layout: "App",
          section: "General",
          breadcrumb: () => "View Re-Insurer",
        },
        children: [
          {
            path: "/",
            element: <ReInsurerPage />,
            meta: {
              layout: "App",
              section: "Clients",
            },
          },
          {
            path: ":offer_participant/payments/:offer",
            element: <ReInsurerPaymentsPage />,
            meta: {
              layout: "App",
              section: "Clients",
              breadcrumb: () => "View Re-Insurer Payments",
            },
          },
        ],
      },
    ],
  },
  {
    path: "brokers",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Reinsurance Brokers",
      section: "Clients",
    },
    sidebar: {
      label: "Reinsurance Brokers",
      icon: BuildingOffice2Icon,
    },
    children: [
      {
        path: "/",
        element: <BrokersPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
      {
        path: ":broker",
        element: <Outlet />,
        meta: {
          layout: "App",
          section: "General",
          breadcrumb: () => "View Broker",
        },
        children: [
          {
            path: "/",
            element: <BrokerPage />,
            meta: {
              layout: "App",
              section: "General",
            },
          },
          {
            path: ":treaty/view",
            element: <Outlet />,
            meta: {
              layout: "App",
              section: "General",
              breadcrumb: () => "View Treaty",
            },
            children: [
              {
                path: "/",
                element: <ViewTreatyPage />,
                meta: {
                  layout: "App",
                  section: "General",
                  // breadcrumb: () => "View Treaty",
                },
              },
              {
                path: ":ref/manage-treaty",
                element: <ManageTreatyPage />,
                meta: {
                  layout: "App",
                  section: "General",
                  breadcrumb: ({ ref }: any) =>
                    `Manage Treaty - ${ref?.replaceAll("__", "/")}`,
                },
              },
            ],
          },
        ],
      },
    ],
    withPermissions: [
      "*:*",
      "reinsurance_brokers:*",
      "reinsurance_brokers:manage",
      "reinsurance_brokers:create",
      "reinsurance_brokers:update",
    ],
  },
  {
    path: "class-of-business",
    element: <Outlet />,
    withDomains: ["Visal", "Comfy"],
    meta: {
      layout: "App",
      breadcrumb: () => "Setup Business",
      section: "Facultative Businesses",
    },
    sidebar: {
      label: "Setup Business",
      icon: DocumentDuplicateIcon,
    },
    children: [
      {
        id: "all",
        path: "/",
        element: <ClassOfBusinessPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
    withPermissions: [
      "*:*",
      "business:*",
      "business:manage",
      "business:create",
      "business:delete",
      "business:update",
    ],
  },
  {
    path: "class-of-business",
    element: <Outlet />,
    withDomains: ["KEK"],
    meta: {
      layout: "App",
      breadcrumb: () => "Setup Business",
      section: "Facultative Businesses",
    },
    sidebar: {
      label: "Setup Business",
      icon: DocumentDuplicateIcon,
    },
    children: [
      {
        id: "all",
        path: "/",
        element: <ClassOFBusinessKEKPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
    withPermissions: [
      "*:*",
      "business:*",
      "business:manage",
      "business:create",
      "business:delete",
      "business:update",
    ],
  },
  {
    path: "claims",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Facultative Claims",
      section: "Facultative Businesses",
    },
    sidebar: {
      label: "Facultative Claims",
      icon: NewspaperIcon,
    },
    withDomains: ["Visal", "Comfy"],
    children: [
      {
        id: "all",
        path: "/",
        element: <ClaimsPage />,
        meta: {
          layout: "App",
          section: "Facultative Businesses",
        },
      },
      {
        id: "all-claims",
        path: "/:offer/view",
        element: <Outlet />,
        meta: {
          layout: "App",
          section: "General",
          breadcrumb: () => "View Claims",
        },
        children: [
          {
            path: "/",
            element: <ViewClaimsPage />,
            meta: {
              layout: "App",
              section: "General",
              // breadcrumb: () => "View Shares",
            },
          },
          {
            id: "all-claims-claim",
            path: ":claim/view",
            element: <Outlet />,
            meta: {
              layout: "App",
              section: "General",
              breadcrumb: () => "View Shares",
            },
            children: [
              {
                path: "/",
                element: <ViewClaimSharesPage />,
                meta: {
                  layout: "App",
                  section: "General",
                  // breadcrumb: () => "View Shares",
                },
              },
              {
                path: ":share/payments",
                element: <ClaimSharePaymentsPage />,
                meta: {
                  layout: "App",
                  section: "General",
                  breadcrumb: () => "View Share Payments",
                },
              },
            ],
          },
        ],
      },
    ],
    withPermissions: [
      "*:*",
      "claims:*",
      "claims:manage",
      "claims:create",
      "claims:delete",
      "claims:update",
    ],
  },
  {
    path: "claims",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Facultative Claims",
      section: "Facultative Businesses",
    },
    sidebar: {
      label: "Facultative Claims",
      icon: NewspaperIcon,
    },
    withDomains: ["KEK"],
    children: [
      {
        id: "all",
        path: "/",
        element: <ClaimsKEKPage />,
        meta: {
          layout: "App",
          section: "Facultative Businesses",
        },
      },
      {
        id: "all-claims",
        path: "/:offer/view",
        element: <Outlet />,
        meta: {
          layout: "App",
          section: "General",
          breadcrumb: () => "View Claims",
        },
        children: [
          {
            path: "/",
            element: <ViewClaimsKEKPage />,
            meta: {
              layout: "App",
              section: "General",
              // breadcrumb: () => "View Shares",
            },
          },
          {
            id: "all-claims-claim",
            path: ":claim/view",
            element: <Outlet />,
            meta: {
              layout: "App",
              section: "General",
              breadcrumb: () => "View Shares",
            },
            children: [
              {
                path: "/",
                element: <ViewClaimsSharesKEKPage />,
                meta: {
                  layout: "App",
                  section: "General",
                  // breadcrumb: () => "View Shares",
                },
              },
              {
                path: ":share/payments",
                element: <ClaimsSharesPaymentKEKPage />,
                meta: {
                  layout: "App",
                  section: "General",
                  breadcrumb: () => "View Share Payments",
                },
              },
            ],
          },
        ],
      },
    ],
    withPermissions: [
      "*:*",
      "claims:*",
      "claims:manage",
      "claims:create",
      "claims:delete",
      "claims:update",
    ],
  },
  {
    path: "employees",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Employees",
      section: "Others",
    },
    sidebar: {
      label: "Employees",
      icon: IdentificationIcon,
    },
    children: [
      {
        id: "all",
        path: "/",
        element: <EmployeesKEKPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
    withDomains: ["KEK", "Visal", "Comfy"],
  },
  {
    path: "settings",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "User Roles",
      section: "Others",
    },
    sidebar: {
      label: "User Roles",
      icon: Cog6ToothIcon,
    },
    children: [
      {
        id: "all",
        path: "/",
        element: <SettingsPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
    // withDomains: ["KEK"],
    withPermissions: [
      "*:*",
      "employees:*",
      "employees:create",
      "employees:manage",
      "employees:delete",
      "employees:reset",
      "employees:update",
    ],
  },
  {
    path: "auto-fac-configurations",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Auto Fac Configurations",
      section: "Others",
    },
    sidebar: {
      label: "Auto Fac Configurations",
      icon: Cog6ToothIcon,
    },
    withDomains: ["Visal", "Comfy"],
    children: [
      {
        id: "all",
        path: "/",
        element: <AutoFacAconfigationsPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
      {
        id: "participants",
        path: ":id/participants",
        element: <AutoFacAconfigationsParticipantsPage />,
        meta: {
          layout: "App",
          breadcrumb: () => "Participants",
          section: "General",
        },
      },
    ],
    withPermissions: [
      "*:*",
      "auto_fac:*",
      "auto_fac:create",
      "auto_fac:manage",
      "auto_fac:view",
      "auto_fac:update",
      "auto_fac:delete",
    ],
  },
  {
    path: "reports",
    element: <Outlet />,
    withDomains: ["Visal", "Comfy"],
    meta: {
      layout: "App",
      breadcrumb: () => "Reports",
      section: "Reports",
    },
    sidebar: {
      label: "Reports",
      icon: ArchiveBoxIcon,
    },
    withPermissions: [
      "*:*",
      "reports:*",
      "reports:manage",
      "reports:create",
      "reports:update",
    ],
    children: [
      {
        id: "all",
        path: "/",
        element: <ReportsPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
  },
  // {
  //   path: "reports",
  //   element: <Outlet />,
  //   withDomains: ["KEK"],
  //   withPermissions: [],
  //   meta: {
  //     layout: "App",
  //     breadcrumb: () => "Reports",
  //     section: "Reports",
  //   },
  //   sidebar: {
  //     label: "Reports",
  //     icon: ArchiveBoxIcon,
  //   },
  //   children: [
  //     {
  //       id: "all",
  //       path: "/",
  //       element: <ReportsKEKPage />,
  //       meta: {
  //         layout: "App",
  //         section: "General",
  //       },
  //     },
  //   ],
  // },
  {
    path: "finance-reports",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Finance Reports",
      section: "Finance",
    },
    sidebar: {
      label: "Finance Reports",
      icon: ArchiveBoxIcon,
    },
    withPermissions: [
      "*:*",
      "reports:*",
      "reports:manage",
      "reports:create",
      "reports:update",
    ],
    withDomains: ["KEK"],
    children: [
      {
        id: "all",
        path: "/",
        element: <FinanceReportsPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
  },
  {
    path: "production-reports",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Production Reports",
      section: "Reports",
    },
    sidebar: {
      label: "Production Reports",
      icon: ArchiveBoxIcon,
    },
    withPermissions: [
      "*:*",
      "reports:*",
      "reports:manage",
      "reports:create",
      "reports:update",
    ],
    withDomains: ["KEK"],
    children: [
      {
        id: "all",
        path: "/",
        element: <ProductionReportsPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
  },
  {
    path: "batch-reports",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Batched Reports",
      section: "Reports",
    },
    sidebar: {
      label: "Batched Reports",
      icon: ArchiveBoxIcon,
    },
    withPermissions: [
      "*:*",
      "reports:*",
      "reports:manage",
      "reports:create",
      "reports:update",
    ],
    children: [
      {
        id: "all",
        path: "/",
        element: <BatchReportingPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
  },
  {
    path: "treaty-programs",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Setup Treaty program",
      section: "Treaty",
    },
    sidebar: {
      label: "Setup Treaty Program",
      icon: RectangleStackIcon,
    },
    withPermissions: [
      "*:*",
      "treaty_program:*",
      "treaty_program:manage",
      "treaty_program:create",
      "treaty_program:update",
    ],
    children: [
      {
        path: "/",
        element: <TreatyProgramsPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
      {
        path: ":treaty_program/view",
        element: <TreatyProgramDeductionsPage />,
        meta: {
          layout: "App",
          breadcrumb: () => "Treaty Program Deductions",
          section: "General",
        },
      },
    ],
  },
  {
    path: "treaties",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Treaties",
      section: "Treaty",
    },
    sidebar: {
      label: "Treaties",
      icon: DocumentDuplicateIcon,
    },
    withPermissions: [
      "*:*",
      "treaties:*",
      "treaties:manage",
      "treaties:create",
      "treaties:update",
      "treaties:delete",
    ],
    children: [
      {
        path: "/",
        element: <TreatiesPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
      {
        path: ":treaty/view",
        element: <Outlet />,
        meta: {
          layout: "App",
          section: "General",
          breadcrumb: () => "View Treaty",
        },
        children: [
          {
            path: "/",
            element: <ViewTreatyPage />,
            meta: {
              layout: "App",
              section: "General",
              // breadcrumb: () => "View Treaty",
            },
          },
          {
            path: ":ref/manage-treaty",
            element: <ManageTreatyPage />,
            meta: {
              layout: "App",
              section: "General",
              breadcrumb: ({ ref }: any) =>
                `Manage Treaty - ${ref?.replaceAll("__", "/")}`,
            },
          },
        ],
      },
    ],
  },
  {
    path: "treaty-claims",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Treaty Claims",
      section: "Treaty",
    },
    sidebar: {
      label: "Treaty Claims",
      icon: CircleStackIcon,
    },
    withPermissions: [
      "*:*",
      "treaty_claims:*",
      "treaty_claims:manage",
      "treaty_claims:create",
      "treaty_claims:update",
      "treaty_claims:delete",
    ],
    children: [
      {
        path: "/",
        element: <TreatyClaimsPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
      {
        path: ":claim/participants/:policy",
        element: <Outlet />,
        meta: {
          layout: "App",
          section: "General",
          breadcrumb: ({ policy }: any) =>
            `Treaty Claim - ${policy?.replaceAll("-", "/")}`,
        },
        children: [
          {
            path: "/",
            element: <TreatyClaimParticipantsPage />,
            meta: {
              layout: "App",
              section: "General",
            },
          },
          {
            path: ":share/payments",
            element: <TreatyClaimPaymentsPage />,
            meta: {
              layout: "App",
              section: "General",
              breadcrumb: ({ policy }: any) => `Treaty Claim Share Payments`,
            },
          },
        ],
      },
    ],
  },
  {
    path: "treaty-reports",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Treaty Reports",
      section: "Treaty",
    },
    sidebar: {
      label: "Treaty Reports",
      icon: ArchiveBoxIcon,
    },
    withPermissions: [
      "*:*",
      "treaties:*",
      "treaties:manage",
      "treaties:create",
      "treaties:update",
      "treaties:import",
    ],
    children: [
      {
        path: "/",
        element: <TreatyReportsPage />,
        meta: {
          layout: "App",
          section: "Treaty",
        },
      },
    ],
  },
  {
    path: "treaty-schedule",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Generate Treaty Payment Schedule",
      section: "Treaty",
    },
    sidebar: {
      label: "Payment Schedules",
      icon: ClipboardDocumentIcon,
    },
    withPermissions: [
      "*:*",
      "treaties:*",
      "treaties:manage",
      "treaties:create",
      "treaties:update",
      "treaties:import",
    ],
    children: [
      {
        path: "/",
        element: <TreatySchedulePage />,
        meta: {
          layout: "App",
          section: "Treaty",
        },
      },
    ],
  },
  {
    path: "underwriters",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Approve Underwriters",
      section: "Place It",
    },
    sidebar: {
      label: "Approve Underwriters",
      icon: UsersIcon,
    },
    withDomains: ["Visal", "Comfy"],
    withPermissions: [
      "*:*",
      "place-it:*",
      "place-it:manage",
      "place-it:approve_underwriters",
    ],

    children: [
      {
        path: "/",
        element: <UnderwritersPage />,
        meta: {
          layout: "App",
          section: "Place It",
        },
      },
    ],
  },
  {
    path: "place-it-offers",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Broker Offers",
      section: "Place It",
    },
    sidebar: {
      label: "Broker Offers",
      icon: RectangleStackIcon,
    },
    withDomains: ["Visal", "Comfy"],
    withPermissions: [
      "*:*",
      "place-it:*",
      "place-it:manage",
      "place-it:approve_offers",
    ],
    children: [
      {
        path: "/",
        element: <PlaceItOffersPage />,
        meta: {
          layout: "App",
          section: "Place It",
        },
      },
    ],
  },
  {
    path: "cancelled-offers",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Cancelled Offers",
      section: "Place It",
    },
    sidebar: {
      label: "Cancelled Offers",
      icon: DocumentMinusIcon,
    },
    withDomains: ["Visal", "Comfy"],
    withPermissions: [
      "*:*",
      "place-it:*",
      "place-it:manage",
      "place-it:approve_underwriters",
    ],

    children: [
      {
        path: "/",
        element: <CancelledOffersPage />,
        meta: {
          layout: "App",
          section: "Place It",
        },
      },
    ],
  },
  {
    path: "place-it-promotions",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Campaigns & Promotions",
      section: "Place It",
    },
    sidebar: {
      label: "Campaigns & Promotions",
      icon: MegaphoneIcon,
    },
    withDomains: ["Visal", "Comfy"],
    withPermissions: [
      "*:*",
      "place-it:*",
      "place-it:manage",
      "place-it:manage_campaigns",
    ],
    children: [
      {
        path: "/",
        element: <PlaceItPromotionsPage />,
        meta: {
          layout: "App",
          section: "Place It",
        },
      },
    ],
  },
  {
    path: "place-it-rewards",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Targets Configuration",
      section: "Place It",
    },
    sidebar: {
      label: "Targets Configuration",
      icon: GiftIcon,
    },
    withDomains: ["Visal", "Comfy"],
    withPermissions: [
      "*:*",
      "place-it:*",
      "place-it:manage",
      "place-it:manage_targets_configuration",
    ],
    children: [
      {
        id: "all",
        path: "/",
        element: <PlaceItRewardsPage />,
        meta: {
          layout: "App",
          section: "Place It",
        },
      },
      {
        id: "targetBadges",
        path: ":id/target-badges",
        element: <TargetBadgesPage />,
        meta: {
          layout: "App",
          section: "Place It",
          breadcrumb: () => "Target Badges",
        },
      },
      {
        id: "targetRates",
        path: ":id/target-rates",
        element: <TargetRatesPage />,
        meta: {
          layout: "App",
          section: "Place It",
          breadcrumb: () => "Target Rates",
        },
      },
    ],
  },
  {
    path: "points-redemptions",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Points Redemptions",
      section: "Place It",
    },
    sidebar: {
      label: "Points Redemptions",
      icon: ClipboardDocumentCheckIcon,
    },
    withDomains: ["Visal", "Comfy"],
    withPermissions: [
      "*:*",
      "place-it:*",
      "place-it:manage",
      "place-it:manage_points_redemptions",
    ],
    children: [
      {
        id: "all",
        path: "/",
        element: <PointRedemptionsPage />,
        meta: {
          layout: "App",
          section: "Place It",
        },
      },
    ],
  },
  {
    path: "notifications",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "System Notifications",
      section: "Notifcations",
    },
    sidebar: {
      label: "System Notifications",
      icon: RectangleStackIcon,
    },
    children: [
      {
        path: "/",
        element: <NotificationsPage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
  },
  {
    path: "profile",
    element: <Outlet />,
    meta: {
      layout: "App",
      breadcrumb: () => "Profile",
      section: "General",
    },
    children: [
      {
        path: "/",
        element: <ProfilePage />,
        meta: {
          layout: "App",
          section: "General",
        },
      },
    ],
  },
  {
    path: "cpanel-login",
    element: <SignInPage />,
    meta: {
      layout: "Auth",
      breadcrumb: () => "Auth",
    },
  },
  {
    path: "cpanel-reset-password",
    element: <ResetPasswordPage />,
    meta: {
      layout: "Auth",
      breadcrumb: () => "Auth",
    },
  },
];

export default routes;
